import { Emdash } from "../Punctuation/Emdash";

// // // //

/**
 * PercentageBar
 * Render a percentage bar
 * @param props.percentage - The percentage to render
 * @returns
 */
export function PercentageBar(props: { percentage: number | null }) {
    const { percentage } = props;

    if (percentage === null) {
        return <Emdash />;
    }

    const value = percentage * 100;
    const displayValue =
        value === 0 ? "0" : value < 0.1 ? "< 0.1" : value.toFixed(1);

    return (
        <div className="flex items-center justify-between w-full gap-1.5">
            <div className="h-2.5 bg-gray-100/50 rounded-xs overflow-hidden flex grow">
                <div
                    className="h-full bg-primary"
                    style={{ width: `${Math.min(value, 100)}%` }}
                />
            </div>
            <span className="text-sm font-medium flex w-12 text-right tabular-nums justify-end">
                {displayValue}%
            </span>
        </div>
    );
}
